import { useMemo } from 'react';
import { useLocale } from 'next-intl';
import { parseISO } from 'date-fns';

import { formatDate } from '~/shared/utils/date';

type FormattedDateProps = {
  date: string;
  options?: Intl.DateTimeFormatOptions;
};

export function FormattedDate({ date, options }: FormattedDateProps) {
  const locale = useLocale();

  const formattedDate = useMemo(() => {
    const dateObject = parseISO(date.toString() ?? '');
    return formatDate(locale, dateObject, options);
  }, [date, locale, options]);

  return <span>{formattedDate}</span>;
}
